import React from 'react';
import Header from './components/header/Header';
import Nav from './components/nav/Nav';
import About from './components/about/About';
import WorkExcperince from './components/workexperience/WorkExperience';
import Experience from './components/experience/Experience';
// import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';

  function App() {
  return (
    <div>
      <Header />
      <Nav />
      <About />
      <WorkExcperince />
      <Experience />
      {/* <Contact /> */}
      <Footer />
    </div>
  );
};

export default App;
